import addParametersToURLs from '../../../helpers/addParametersToURLs';

function addParamsToURL(url, paramsObject) {
  const addParamsToMe = addParametersToURLs(url);
  return addParamsToMe(paramsObject);
}

const flashHash = {
  success: '#flash-success-upgrade',
  failure: '#flash-error-upgrade-failure',
  error: '#flash-error-upgrade-error',
};

const getCustomStripeUrls = (siteObject, stripeReturnPaths) => {
  const baseUrl = `${siteObject.base_url}/`;
  // are we sure we should be using success for all three urls?
  // Seems to defeat the purpose
  return {
    success: `${baseUrl}${stripeReturnPaths.success}${flashHash.success}`,
    failure: `${baseUrl}${stripeReturnPaths.success}${flashHash.failure}`,
    error: `${baseUrl}${stripeReturnPaths.success}${flashHash.error}`,
  };
};

const getContactAdvertiserStripeUrls = (siteObject, advertID, pageData) => {
  const {
    alert_id,
    alert_type,
    search: { city_id, id: search_id, results: search_results },
    advert: { featured, id: flatshare_id, type: flatshare_type },
    contact_mode: submode,
    upgrade_required,
  } = pageData;

  const data = {
    alert_id,
    alert_type,
    city_id,
    featured,
    flatshare_id,
    flatshare_type,
    mode: 'contact',
    search_id,
    search_results,
    submode,
    upgrade_required: upgrade_required ? 1 : 0,
  };
  const base_url = `${siteObject.base_url}/${siteObject.sub_dir}/${siteObject.script_path}`;
  const addParamsToBaseURL = addParametersToURLs(base_url);
  const failureUrl = addParamsToBaseURL(data);
  data.upgrade_required = 0;
  const successUrl = addParamsToBaseURL(data);
  return {
    success: `${successUrl}${flashHash.success}`,
    failure: `${failureUrl}${flashHash.failure}`,
    error: `${base_url}?flatshare_id=${advertID}${flashHash.error}`,
  };
};

const getMyAccountStripeUrls = (siteObject) => {
  const base_url = `${siteObject.base_url}${siteObject.my_account_directory}`;
  const currentUrl = window.location.href.split('#')[0];
  return {
    success: `${base_url}${flashHash.success}`,
    failure: `${currentUrl}${flashHash.failure}`,
    error: `${base_url}${flashHash.error}`,
  };
};

const getDefaultStripeUrls = () => {
  const currentUrl = window.location.href.split('#')[0];
  return {
    success: `${currentUrl}${flashHash.success}`,
    failure: `${currentUrl}${flashHash.failure}`,
    error: `${currentUrl}${flashHash.error}`,
  };
};

// this is an excellent example of over abstraction.
const getStripeUrls = (
  siteObject,
  context,
  advertID = '',
  stripeReturnPaths,
  pageData = {},
) => {
  if (context == 'global' && stripeReturnPaths) {
    return getCustomStripeUrls(siteObject, stripeReturnPaths);
  }
  if (context == 'contact_advertiser') {
    return getContactAdvertiserStripeUrls(siteObject, advertID, pageData);
  }
  if (context == 'my_account') {
    return getMyAccountStripeUrls(siteObject);
  }
  return getDefaultStripeUrls();
};

const addMessageToUrl = (url, message) => {
  return addParamsToURL(url, { M_message: message });
  // const paramPrefix = url.includes('?') ? '&' : '?';
  // const pieces = url.split('#');
  // return `${pieces[0] + paramPrefix}M_message=${encodeURIComponent(message)}#${
  //   pieces[1]
  // }`;
};

const addMessageParamToReturnUrls = (urls, message) => ({
  success: addMessageToUrl(urls.success, message),
  failure: addMessageToUrl(urls.failure, message),
  error: addMessageToUrl(urls.error, message),
});

export { getStripeUrls, addMessageParamToReturnUrls };
